import React from 'react';
import styled, { keyframes } from 'styled-components';
import Countdown from 'react-countdown';
import { useBondingCurve } from '@onomy/react-hub';

import logoSrc from '../assets/logo.svg';
import { responsive } from 'theme/constants';
import { REACT_APP_ETH_NETWORK_NAME } from 'constants/env';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  height: 100vh;
  width: 100vw;
  padding: 15px;

  position: relative;

  text-align: center;
`;

const Caption = styled.h1`
  margin: 0;

  font-size: 32px;

  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    font-size: 20px;
  }
`;

const CountdownText = styled.span`
  font-family: Barlow Condensed, sans-serif;
  font-size: 80px;
  line-height: 1;

  @media screen and (max-width: ${responsive.smartphoneLarge}) {
    font-size: 50px;
  }
`;

const pulseBlur = keyframes`
  0% {
    opacity: 0.01;
    filter: blur(10px); 
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    opacity: 0.02;
    filter: blur(5px); 
    transform: translate(-50%, -50%) scale(1.05);
  }
  
  100% {
    opacity: 0.01;
    filter: blur(10px); 
    transform: translate(-50%, -50%) scale(1);
  }
`;

const Logo = styled.img`
  width: 50vw;
  height: 50vh;

  position: absolute;
  top: 50%;
  left: 50%;

  z-index: -1;
  animation: ${pulseBlur} 2s infinite;

  @media screen and (max-width: ${responsive.smartphone}) {
    width: 80vw;
    height: 80vh;
  }
`;

const TRADE_DATE = Date.UTC(2022, 11, 6, 15);

export function RequireTradingEnabled({ children }: { children: JSX.Element | JSX.Element[] }) {
  const { isTradingEnabled } = useBondingCurve();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (isTradingEnabled || REACT_APP_ETH_NETWORK_NAME !== 'homestead') return <>{children}</>;

  // Renderer callback with condition
  const renderer = ({
    days,
    completed,
    formatted,
  }: {
    days: number;
    formatted: any;
    completed: boolean;
  }) => {
    if (completed) {
      return <h2>Trading should be live any moment now</h2>;
    }

    return (
      <CountdownText>
        {days} Day{formatted.days > 1 ? 's' : ''} {formatted?.hours}h {formatted?.minutes}m{' '}
        {formatted?.seconds}s
      </CountdownText>
    );
  };

  return (
    <Wrapper>
      <Caption>
        Load your engines! <wbr />
        Trading begins in...
      </Caption>
      <Countdown date={TRADE_DATE} renderer={renderer} />
      <Logo src={logoSrc} alt="" />
    </Wrapper>
  );
}
